import * as type from "../../types/API/inventoryServices";
import { IAction } from "../userMetadataReducer";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const getInventoryServiceReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.GET_INVENTORY_SERVICES:
      return {
        ...state,
        loading: true,
      };
    case type.GET_INVENTORY_SERVICES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData,
      };
    case type.GET_INVENTORY_SERVICES_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const addInventoryServiceReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.ADD_INVENTORY_SERVICES:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.ADD_INVENTORY_SERVICES_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.ADD_INVENTORY_SERVICES_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const editInventoryServiceReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.EDIT_INVENTORY_SERVICES:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.EDIT_INVENTORY_SERVICES_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.EDIT_INVENTORY_SERVICES_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const deleteInventoryServiceReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.DELETE_INVENTORY_SERVICES:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.DELETE_INVENTORY_SERVICES_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.DELETE_INVENTORY_SERVICES_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};
 